import { render, staticRenderFns } from "./ProxiesPage.vue?vue&type=template&id=1d4e10aa"
import script from "./ProxiesPage.vue?vue&type=script&lang=js"
export * from "./ProxiesPage.vue?vue&type=script&lang=js"
import style0 from "./ProxiesPage.vue?vue&type=style&index=0&id=1d4e10aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports